<c-card *transloco="let t">
  <c-card-body class="px-2">


          <c-row>
            <c-col md="12" lg="6">
                <h3>{{ t('Add a Worker') }}</h3>
            </c-col>
            <c-col md="12" lg="6" class="text-end mb-2">

              <div class="btn-group mb-2 " role="group">
              <button color="light" cButton class="me-1" routerLink="/mgmt/workers/workers">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Workers') }}
              </button>
              <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
            </div>

            </c-col>
          </c-row>

          <ng-container *ngIf=" okService.billing.plan.workers.limited">
            <div class="alert alert-warning" role="alert">
            <i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('You have reached your worker limit of') }} {{okService.billing.plan.workers.max}}. {{ t('Please update your plan to add more workers') }} - <a routerLink="/account">{{ t('Account Settings') }}</a>.
            </div>
          </ng-container>

          <ng-container *ngIf="!okService.billing.plan.workers.limited">

        <c-row class="justify-content-left">
          <c-col>
                  <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">

                    <div class="row">
                      <div class="col-12 col-md-6">



                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'name'"
                              cFormControl
                              placeholder="{{ t('Name') }}"
                              [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('A suitable name for this worker account')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                              {{ t('A valid name is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Phone') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone'"
                              cFormControl
                              placeholder="{{ t('Phone') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The phone number used to contact the worker. This is required for SMS text/Phonecall Check Ins and Automated Check In options')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">
                              {{ t('A valid phone number is required') }}
                            </div>
                            <div class="row my-1">
                              <div class="col-12">
                                <i class="fas fa-info-circle text-info"></i> {{ t('If the worker should receive SMS messages please use a cell number.') }}
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'email'"
                              cFormControl
                              placeholder="{{ t('Email') }}"
                              [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Email is optional for workers, but is used for start shift reminders and for linking to Google Assistant.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                              {{ t('A valid email is required') }}
                            </div>
                          </div>
                        </div>


                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilAlarm"></svg> {{ t('Check In Frequency') }}</label>
                          <div class="col-8">
                            <ng-select
                              [items]="check_in_times"
                              bindLabel="name"
                              bindValue="value"
                              formControlName="check_in_freq"
                              placeholder="{{ t('Check In Frequency') }}"
                            >
                            <option  *ngFor="let check_in_time of check_in_times" [value]="check_in_time.value">{{check_in_time.name}}</option>
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How often the user must check in to let the monitor know they are ok.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>



                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}</label>
                          <div class="col-8">

                            <ng-select [items]="okService.monitors"
                                      bindLabel="name"
                                      bindValue="id"
                                      [multiple]="true"
                                      formControlName="monitors">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose monitors from the list, they will get alerts for missed check ins and help alerts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['monitors'].errors" class="invalid-feedback">
                              {{ t('Please choose at least one monitor') }}
                            </div>
                          </div>
                        </div>



                        <div class="form-group row mb-2"  *ngIf="okService.groups.length > 0">
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilGrain"></svg> {{ t('Groups') }}</label>
                          <div class="col-8">

                            <ng-select [items]="okService.groups"
                                      bindLabel="name"
                                      bindValue="id"
                                      [multiple]="true"
                                      formControlName="groups">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose groups from the list, workers may only be synced with one group at a time')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>

                        <ng-container *ngIf="okService.groups.length > 0">
                          <div class="form-group row mb-2" *ngIf="formGroup.value.groups.length > 0">
                            <div class="col-8">
                              <input type="checkbox" class="form-check-input" formControlName="sync_group" name="sync_group">
                              <label class="form-check-label" for="sync_group">&nbsp;{{ t('Synchronize the worker with the group settings') }}</label>
                            </div>
                          </div>
                        </ng-container>


                        <div class="form-group row mb-2" *ngIf="okService.isGeotab()">
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cil-car-alt"></svg> {{ t('Vehicles') }}</label>
                          <div class="col-8">

                            <ng-select [items]="okService.vehicles"
                                      bindLabel="name"
                                      bindValue="id"
                                      formControlName="vehicle_id">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Assign at vehicle to the worker')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <p class="fw-light">{{ t('Only enabled vehicles appear in this list, enable them on the vehicles page.') }}</p>
                          </div>
                        </div>

                        <ng-container *ngIf="okService.settings.international">


                          <div class="form-group row mb-2" >
                            <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilLocationPin"></svg> {{ t('Country') }}</label>
                            <div class="col-8">
                              <ng-select [items]="countryListArray"
                              bindLabel="name"
                              bindValue="code"
                              formControlName="country"
                              placeholder="{{ t('Country') }}">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The country of the worker, required if they are in another country to the account country')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>

                          <div class="form-group row mb-2" >
                            <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-globe"></i> {{ t('Timezone') }}</label>
                            <div class="col-8">
                              <ng-select [items]="timezoneListArray"
                                        bindLabel="label"
                                        bindValue="tzCode"
                                        formControlName="timezone"
                                        placeholder="{{ t('Timezone') }}">
                              </ng-select>
                              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The timezone of the worker, required if they are in another timezone to the account timezone')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>



                      </ng-container>



                      <div class="form-group row mb-2"  *ngIf="formGroup.value.phone.length > 0">
                        <div class="col-8">
                          <input type="checkbox" class="form-check-input" formControlName="welcome" name="welcome">
                          <label class="form-check-label" for="welcome">&nbsp;{{ t('Send app link and PIN to worker') }}</label>
                        </div>
                      </div>

                      <ng-container *ngIf="okService.hasFeature('learning_center')">
                        <div class="form-group row mb-2"  *ngIf="formGroup.value.phone.length > 0 || formGroup.value.email.length >0">
                          <div class="col-8">
                            <input type="checkbox" class="form-check-input" formControlName="learning" name="learning">
                            <label class="form-check-label" for="learning">&nbsp;{{ t('Send Learning Center link to the worker') }}</label>
                          </div>
                        </div>
                      </ng-container>



                      


                      </div>
                      <div class="col-12 col-md-6">


                        <p>{{ t('How will this worker use OK Alone:') }}</p>
                        <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
                        <button type="button" class="btn " [ngClass]="this.formGroup.value.device!='Cell Phone' ? 'text-light btn-success' : 'btn-outline-secondary text-dark'" (click)="setDevice('Smartphone')">
                          <c-row>
                            <c-col class="col-12 col-md-4">
                              <img src="assets/images/worker-smartphone.png" alt="Worker Smartphone" class="" height="100px"/>
                            </c-col>
                            <c-col class="col-12 col-md-8 text-left">
                                <p>
                                  <span class="fs-3">{{ t('Smartphone App') }}</span><br/>
                                  {{ t('This worker has an iPhone or Android phone and they will use the OK Alone app to check in.') }}
                                </p>
                            </c-col>
                          </c-row>
                        </button>
                        <button type="button" class="btn btn-outline-secondary  text-dark" [ngClass]="this.formGroup.value.device=='Cell Phone' ? 'text-light btn-success' : 'btn-outline-secondary text-dark'" (click)="setDevice('Cell Phone')">
                          <c-row>
                            <c-col class="col-12 col-md-4">
                              <img src="assets/images/worker-mobile2.png" alt="Worker Older Phone" class="" height="100px"/>
                            </c-col>
                            <c-col class="col-12 col-md-8 text-left">
                                <p>
                                  <span class="fs-3">{{ t('Older Phone') }}</span><br/>
                                  {{ t('This worker has an older phone and will check in by sending a text message or making a phone call to OK Alone.') }}
                                </p>
                            </c-col>
                          </c-row>
                        </button>
                      </div>

                      </div>

                    </div>

                    <c-row>
                      <c-col xs="6" class="mt-3">
                        <button cButton class="px-4 text-white btn-info" type="submit" [disabled]="submitting">
                          <i class="fa-solid fa-plus"></i> {{ t('Add a Worker') }}
                        </button>
                      </c-col>
                    </c-row>
                  </form>
          </c-col>
        </c-row>
      </ng-container>

  </c-card-body>
</c-card>
